import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiConstant } from '../app.constant';
import { environment } from 'src/environments/environment';
import { AgencyLoginGroup } from '../app.model';

@Injectable({
  providedIn: 'root'
})
export class AgencyLoginAccessService {

  private baseUrl = `${environment.baseUrl}`;

  constructor(private http: HttpClient) { }

  getLoginAccess(agencyUuid: string) {
    return this.http.get<{ data: AgencyLoginGroup[], all_disabled: boolean }>(
      this.baseUrl + apiConstant.AGENCIES + '/' + agencyUuid + '/' + apiConstant.AGENCY_LOGIN_ACCESS);
  }

  updateLoginAccess(agencyUuid: string, groups: { [key: string]: boolean }) {
    return this.http.put<{ data: AgencyLoginGroup[], all_disabled: boolean }>(
      this.baseUrl + apiConstant.AGENCIES + '/' + agencyUuid + '/' + apiConstant.AGENCY_LOGIN_ACCESS, { groups });
  }
}
